import { takeEvery, put, call } from "redux-saga/effects"

// Login Redux States
import { FORGET_PASSWORD } from "./actionTypes"
import { userForgetPasswordSuccess, apiError } from "./actions"

import { postJwtForgetPwd } from "../../../helpers/backend_helper"

//If user is send successfully send mail link then dispatch redux action's are directly from here.
function* forgetUser({ payload: { user, history } }) {
  try {
    const response = yield call(postJwtForgetPwd, { workEmail: user.workEmail })
    if (response) {
      yield put(userForgetPasswordSuccess("Reset link is sent to your mailbox, check there first"))
    }
  } catch (error) {
    const errorMessage = [error.response.data.error]
    yield put(apiError(errorMessage))
  }
}

function* forgetPasswordSaga() {
  yield takeEvery(FORGET_PASSWORD, forgetUser)
}

export default forgetPasswordSaga
